import { useConversationByContact } from "views/inbox/api/use-conversation-by-contact";
import type { ApplicantOrInvitee } from "../types";

// Unread chat count for an applicant card, taken from the applicant's native
// conversation. Skipped when the partner has chat off so a long table doesn't
// fire one poll per row.
export const useApplicantChatUnreads = ({
  applicant,
  hasChat
}: {
  applicant: ApplicantOrInvitee;
  hasChat: boolean;
}): number => {
  const nativeContactId =
    hasChat && "verifications" in applicant
      ? applicant.crm_contact_id
      : undefined;
  const { data: nativeConversation } = useConversationByContact(
    nativeContactId,
    { refetchInterval: 15_000 }
  );

  return nativeConversation?.conversation.unread_count ?? 0;
};
